import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartColumn } from "@fortawesome/free-solid-svg-icons";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

type DashboardCardEmptyStateProps = {
  isFullScreen?: boolean;
  icon?: IconDefinition;
  title?: string;
  subtitle?: string;
};

export const DashboardCardEmptyState: React.FC<DashboardCardEmptyStateProps> = ({
  isFullScreen,
  icon = faChartColumn,
  title = "No data to display",
  subtitle = "There's nothing recorded for the selected date and shift.",
}) => (
  <div className="animate-fade-in h-full w-full flex flex-col items-center justify-center gap-3 px-6 py-10 text-center text-theme-text-muted">
    <div
      className={`flex items-center justify-center rounded-full border border-theme-border bg-theme-surface ${
        isFullScreen ? "h-28 w-28" : "h-20 w-20"
      }`}
    >
      <FontAwesomeIcon
        icon={icon}
        className={`text-theme-text-muted ${isFullScreen ? "text-5xl" : "text-3xl"}`}
      />
    </div>
    <p className={`font-semibold text-theme-text ${isFullScreen ? "text-3xl" : "text-xl"}`}>
      {title}
    </p>
    <p className={`max-w-[28rem] ${isFullScreen ? "text-lg" : "text-sm"}`}>{subtitle}</p>
  </div>
);
